const MIME_TO_EXT: Record<string, string> = {
  "audio/ogg": "ogg",
  "audio/opus": "ogg",
  "audio/mp4": "mp4",
  "audio/x-m4a": "m4a",
  "audio/wav": "wav",
  "audio/x-wav": "wav",
  "audio/flac": "flac",
  "audio/webm": "webm",
  "audio/aac": "aac",
  "audio/mpeg": "mp3",
  "video/mp4": "mp4",
  "video/webm": "webm",
};

export function getMimeExtension(mimeType: string): string {
  const base = mimeType.split(";")[0].trim().toLowerCase();
  return MIME_TO_EXT[base] ?? (base.includes("ogg") || base.includes("opus") ? "ogg" : "mp3");
}

export function triggerBlobDownload(blob: Blob, title: string): void {
  const blobUrl = URL.createObjectURL(blob);
  const ext = getMimeExtension(blob.type);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = `ElevenLabs_${title.slice(0, 100).replace(/\./g, "").replace(/ /g, "_")}.${ext}`;
  a.click();
  URL.revokeObjectURL(blobUrl);
}
